<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.LiveVoting' | translate }}</mat-card-title>
        <button class="header-button" mat-flat-button color="primary" (click)="vote()">
            <span class="material-icons m-2">how_to_vote</span>
            {{ 'Voting.Vote' | translate }}
        </button>
    </mat-card-header>
    <mat-card-content>
        @if (isLoading() || isStatusCheckLoading()) {
            <mat-progress-bar mode="indeterminate" />
        } @else if (isCheckedIn()) {
            @if (isDisconnected()) {
                <div>
                    <span>{{ 'General.PleaseRefresh' | translate }}</span>
                    <span>{{ errorMessage() }}</span>
                </div>
            } @else if (currentVoting().length > 0) {
                @for (item of currentVoting(); track item.gmAgendaItemNumber) {
                    <!-- ignore children -->
                    @if (!item.parentGmAgendaItemNumber) {
                        <ng-container
                            *ngTemplateOutlet="
                                !hasChildren(item) ? noChildren : withChildren;
                                context: { item: item, children: getChildren(item) }
                            " />
                    }
                }

                <ng-template #withChildren let-item="item" let-children="children">
                    <!-- Template with children -->
                    <div class="agenda-item with-children" [attr.data-voting-active]="item.isVotingOpen">
                        <div class="agenda-item-heading">
                            <h3 class="agenda-item-title">{{ item.number }} - {{ item.description }}</h3>
                        </div>
                        <div class="children-wrapper">
                            @for (child of children; track child.gmAgendaItemNumber) {
                                <div class="child" [attr.data-voting-active]="child.isVotingOpen">
                                    <div class="child-title">
                                        <h4>{{ child.number }} - {{ child.description }}</h4>
                                        @if (child.isVotingOpen) {
                                            <div class="voting-open-indicator">
                                                {{ 'LiveVoting.VotingOpen' | translate }}
                                            </div>
                                        } @else if (!!child.resultAcceptedTime) {
                                            <div class="voting-accepted-indicator">
                                                {{ 'LiveVoting.VotingClosed' | translate }}
                                            </div>
                                        }
                                    </div>

                                    <div class="results-wrapper">
                                        <div class="vote-description">
                                            {{ 'LiveVoting.YourVote' | translate }} : {{ child.voteDescription }}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </ng-template>

                <ng-template #noChildren let-item="item">
                    <!-- no children template -->
                    <div class="agenda-item no-children" [attr.data-voting-active]="item.isVotingOpen">
                        <div class="agenda-item-heading">
                            <h3 class="agenda-item-title">{{ item.number }} - {{ item.description }}</h3>
                            @if (item.isVotingOpen) {
                                <div class="voting-open-indicator">
                                    {{ 'LiveVoting.VotingOpen' | translate }}
                                </div>
                            } @else if (!!item.resultAcceptedTime) {
                                <div class="voting-accepted-indicator">
                                    {{ 'LiveVoting.VotingClosed' | translate }}
                                </div>
                            }
                        </div>

                        <div class="results-wrapper">
                            <div class="vote-description">{{ 'LiveVoting.YourVote' | translate }}: {{ item.voteDescription }}</div>
                        </div>
                    </div>
                </ng-template>

                <ng-template #vote let-vm>
                    <button mat-flat-button color="primary" (click)="vm.vote()">
                        <span class="material-icons m-2">how_to_vote</span>
                        {{ 'Voting.Vote' | translate }}
                    </button>
                </ng-template>
            } @else {
                <div class="no-voting">
                    <div class="material-icons">how_to_vote</div>
                    <div class="no-voting-message">{{ 'LiveVoting.NoVoting' | translate }}</div>
                </div>
            }
        } @else {
            <div class="not-checked-in">
                <div>
                    <div class="title">
                        {{ 'Dashboard.LiveVoting' | translate }}
                    </div>
                    <div>
                        {{ 'LiveVoting.CheckInToVote' | translate }}
                    </div>
                    <div class="button-wrapper">
                        <button mat-flat-button (click)="onCheckIn()" color="primary">
                            {{ 'GeneralMeeting.CheckIn' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        }
    </mat-card-content>
</mat-card>
